import { useTranslation } from 'react-i18next';

const StatusBook = ({ value }) => {
    const { t } = useTranslation();

    const statusMap = {
        LINKED: t('books.linked'),
        RE_LINKED: t('books.relinked'),
        UNLINKED: t('books.unlinked'),
    };

    return statusMap[value] || '-';
};

export default StatusBook;
